import React, { useState, useEffect, useCallback } from 'react';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ConsultNoteEditModal from './ConsultNoteEditModal';
import moment from 'moment';
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
  IconButton,
  AppBar,
  Tabs,
  Tab,
} from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Badge from '@material-ui/core/Badge';
import TabPanel from './TabPanel';
import {
  createConsultNote,
  getConsultNotes,
  fetchPatientById,
  getChildConsultNotes,
  markReadStatusOnPatientNotification,
  getPatientAllMessages,
} from '../services/api';
import * as authApi from '../services/api/auth';

const CHILD_BY_ID_TAB = 1;
const PAGE_LIMIT = 20;

function PatientChartConsultNotes(props) {
  const { getCommonCount, classes } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [consultNotes, setConsultNotes] = useState([]);
  const [tabPosition, setTabPosition] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [openConsultNoteEditModal, setOpenConsultNoteEditModal] = useState(
    false
  );
  const [noteUnderEdit, setNoteUnderEdit] = useState({});
  const [viewOnly, setViewOnly] = useState(true);
  const [providersSearchId, setProvidersSearchId] = useState(null);
  const [patientsSearchId, setPatientsSearchId] = useState(null);
  const [inspectedConsultNote, setInspectedConsultNote] = useState(null);
  const [parentCount, setParentCount] = useState(0);
  const [childCount, setChildCount] = useState(0);
  const [messageData, setMessageData] = useState([]);

  useEffect(() => {
    (async () => {
      getConsultNotesInfo();
    })();
  }, []);

  const getConsultNotesInfo = async () => {
    setIsLoading(true);
    const { history } = props;
    try {
      const currUser = await authApi.fetchCurrentUser();
      setCurrentUser(currUser);
      const currPatient = await fetchPatientById(currUser.patient.id);
      const getAllMessages = await getPatientAllMessages(currUser.patient.id);
      let childMessageCount = 0;
      getAllMessages &&
        getAllMessages.map(item => {
          if (item.role == 'parent') {
            setParentCount(item.messageCount);
          } else if (item.role == 'child') {
            childMessageCount += item.messageCount;
            setChildCount(childMessageCount);
          }
        });
      setMessageData(getAllMessages);
      if (currPatient.id) {
        const fetchedConsultNotes = await getConsultNotes(
          currPatient.id,
          PAGE_LIMIT,
          pageIndex * 20
        );
        setIsLoading(false);
        setConsultNotes(fetchedConsultNotes);
        patientMessageInfo();
      }
    } catch (err) {
      setIsLoading(false);
      props.enqueueSnackbar(
        'There was a problem finding your account, please login again.',
        {
          preventDuplicate: true,
          autoHideDuration: 3000,
        }
      );
      history.push('/login');
    }
  };

  useEffect(() => {
    (async () => {
      fetchConsultNotes();
    })();
  }, [pageIndex, tabPosition]);

  /**
   * get Parent and Child consultNotes
   */
  const fetchConsultNotes = async () => {
    setIsLoading(true);
    const { history } = props;
    try {
      const currUser = await authApi.fetchCurrentUser();
      const currPatient = await fetchPatientById(currUser.patient.id);
      if (currPatient.id) {
        let fetchedConsultNotes = [];
        // CHILD_BY_ID_TAB === 1
        if (tabPosition === CHILD_BY_ID_TAB) {
          fetchedConsultNotes = await getChildConsultNotes(
            currPatient.id,
            PAGE_LIMIT,
            pageIndex * 20
          );
        } else {
          fetchedConsultNotes = await getConsultNotes(
            currPatient.id,
            PAGE_LIMIT,
            pageIndex * 20
          );
        }
        setIsLoading(false);
        setConsultNotes(fetchedConsultNotes);
      }
    } catch (err) {
      setIsLoading(false);
      props.enqueueSnackbar(
        'There was a problem finding your account, please login again.',
        {
          preventDuplicate: true,
          autoHideDuration: 3000,
        }
      );
      history.push('/login');
    }
  };

  /**
   * get parentMessageCount and childMessageCount
   */
  const patientMessageInfo = async () => {
    const currentUser = await authApi.fetchCurrentUser();
    const getAllMessages = await getPatientAllMessages(currentUser.patient.id);
    let childMessageCount = 0;
    getAllMessages &&
      getAllMessages.map(item => {
        if (item.role == 'parent') {
          setParentCount(item.messageCount);
        } else if (item.role == 'child') {
          childMessageCount += item.messageCount;
          setChildCount(childMessageCount);
        }
      });
  };

  /**
   * @param {*} consultNote
   * @returns
   */
  const updateReadMessage = consultNote => {
    if (
      consultNote &&
      consultNote.patientNotifications &&
      consultNote.patientNotifications.id &&
      tabPosition === 0
    ) {
      markReadStatus(consultNote.patientNotifications.id);
      fetchConsultNotes();
      patientMessageInfo();
    } else if (
      consultNote &&
      consultNote.patientNotifications &&
      consultNote.patientNotifications.id &&
      tabPosition === 1
    ) {
      markReadStatus(consultNote.patientNotifications.id);
      fetchConsultNotes();
      patientMessageInfo();
    }
  };

  /**
   * @param {*} params
   * type : message || appointment_Request have two enum
   * @param {*} type = 'message'
   * MarkRead status by calling API
   */
  const markReadStatus = async (params, type = 'message') => {
    try {
      await markReadStatusOnPatientNotification(params, type);
    } catch (error) {
      props.enqueueSnackbar('Oops, something went wrong. Please Try again', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  };

  const sendConsultNote = async noteParams => {
    try {
      await createConsultNote(noteParams);
      getConsultNotes();
      enqueueSnackbar('Successfully sent note!');
      setOpenConsultNoteEditModal(false);
    } catch (err) {
      enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  const handleTabPositionChange = (event, newTabPosition) => {
    setPageIndex(0);
    setTabPosition(newTabPosition);
  };

  const name = { nam: currentUser && currentUser.name };
  const userId = String(name.nam);

  const onViewConsultNote = note => {
    setNoteUnderEdit(note);
    setOpenConsultNoteEditModal(true);
    setViewOnly(true);
  };

  const onCloseModal = () => {
    setNoteUnderEdit({});
    setOpenConsultNoteEditModal(false);
  };

  const onPageForward = () => {
    //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
    if (consultNotes.length < PAGE_LIMIT) {
      enqueueSnackbar('You are on the last page');
    } else {
      setPageIndex(pageIndex + 1);
    }
  };

  const onPageBack = () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  /**
   * onClick to open consultNote PopUp modal
   * @param {*} consultNote
   * @param {*} event
   */
  const handleInspectedConsultNote = (event, consultNote) => {
    setInspectedConsultNote(consultNote);
    updateReadMessage(consultNote);
    // getCommonCount && getCommonCount();
  };

  return (
    <Grid container classes={{ container: classes.container }}>
      <AppBar
        position="static"
        color="default"
        classes={{ root: classes.appBar }}
      >
        <Tabs value={tabPosition} onChange={handleTabPositionChange}>
          {parentCount > 0 ? (
            <Tab
              label={
                <Badge
                  badgeContent={parentCount}
                  color="primary"
                  className="update-badge update-badge-right"
                >
                  Messages
                </Badge>
              }
            />
          ) : (
            <Tab
              label={
                <Badge
                  badgeContent={null}
                  color="primary"
                  className="update-badge"
                >
                  Messages
                </Badge>
              }
            />
          )}
          {childCount > 0 ? (
            <Tab
              label={
                <Badge
                  badgeContent={childCount}
                  color="primary"
                  className="update-badge update-badge-right"
                >
                  Child Reports
                </Badge>
              }
            />
          ) : (
            <Tab
              label={
                <Badge
                  badgeContent={null}
                  color="primary"
                  className="update-badge"
                >
                  Child Reports
                </Badge>
              }
            />
          )}
        </Tabs>
      </AppBar>

      <TabPanel>
        <Grid container item xs={12}>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <Table>
                <TableHead>
                  <TableRow className="tabHeadTitle">
                    <TableCell>From</TableCell>
                    <TableCell>To</TableCell>
                    {tabPosition === CHILD_BY_ID_TAB && (
                      <TableCell>Child</TableCell>
                    )}
                    <TableCell>Created At</TableCell>
                    <TableCell>Message/Report</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {consultNotes
                    .sort((c1, c2) =>
                      moment(c1.createdAt).isAfter(c2.createdAt) ? -1 : 1
                    )
                    .map(consultNote => (
                      <TableRow
                        key={consultNote.id}
                        className={
                          consultNote.patientNotifications &&
                          consultNote.patientNotifications.isRead === false
                            ? 'unread-msgs'
                            : ''
                        }
                      >
                        <TableCell className="unread-dot">
                          {consultNote.fromProvider.name}
                        </TableCell>
                        <TableCell>{consultNote.toProvider.name}</TableCell>
                        {tabPosition === CHILD_BY_ID_TAB && (
                          <TableCell>{consultNote.patient.name}</TableCell>
                        )}
                        <TableCell>
                          {moment(consultNote.createdAt).format(
                            'YYYY-MM-DD h:mma'
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            onClick={e =>
                              handleInspectedConsultNote(e, consultNote)
                            }
                          >
                            <RemoveRedEyeIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>

              <div className={classes.pageTurners}>
                <IconButton disabled={pageIndex === 0}>
                  <ArrowBackIosIcon
                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={onPageBack}
                  />
                </IconButton>
                <IconButton disabled={consultNotes.length < PAGE_LIMIT}>
                  <ArrowForwardIosIcon
                    style={{
                      opacity: consultNotes.length < PAGE_LIMIT ? '0.5' : '1.0',
                    }}
                    color="primary"
                    variant="contained"
                    onClick={onPageForward}
                  />
                </IconButton>
              </div>
            </>
          )}
        </Grid>
      </TabPanel>
      {inspectedConsultNote && (
        <ConsultNoteEditModal
          viewOnly
          open={!!inspectedConsultNote}
          note={{
            id: inspectedConsultNote.id,
            body: inspectedConsultNote.body,
            patientId: inspectedConsultNote.patient.id,
            patientName: inspectedConsultNote.patient.name,
            toProviderId: inspectedConsultNote.toProvider.id,
            toProviderName: inspectedConsultNote.toProvider.name,
            toProviderImageUrl: inspectedConsultNote.toProvider.imageUrl,
            toProviderUrl: inspectedConsultNote.toProvider.providerUrl,
            fromProviderId: inspectedConsultNote.fromProvider.id,
            fromProviderName: inspectedConsultNote.fromProvider.name,
            fromProviderImageUrl: inspectedConsultNote.fromProvider.imageUrl,
            fromProviderUrl: inspectedConsultNote.fromProvider.providerUrl,
            archivedById: inspectedConsultNote.archivedById,
            createdAt: inspectedConsultNote.createdAt,
          }}
          onClose={() => setInspectedConsultNote(null)}
        />
      )}
    </Grid>
  );
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '1.2em',
    color: '#1C1C1C',
  },
  actions: {
    textAlign: 'right',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default withStyles(styles)(PatientChartConsultNotes);
